export const holidaysList = [
  { date: "26-01-2025", reason: "Republic Day", day: "Sunday" },
  { date: "26-02-2025", reason: "Maha Sivaratri", day: "Wednesday" },
  { date: "14-03-2025", reason: "Holi", day: "Friday" },
  { date: "31-03-2025", reason: "Idul Fitr", day: "Monday" },
  { date: "10-04-2025", reason: "Mahavir Jayanti", day: "Thursday" },
  { date: "18-04-2025", reason: "Good Friday", day: "Friday" },
  { date: "12-05-2025", reason: "Buddha Purnima", day: "Monday" },
  { date: "07-06-2025", reason: "Bakrid / Eid al Adha", day: "Saturday" },
  { date: "06-07-2025", reason: "Muharram", day: "Sunday" },
  { date: "15-08-2025", reason: "Independence Day", day: "Friday" },
  { date: "16-08-2025", reason: "Janmashtami", day: "Saturday" },
  { date: "05-09-2025", reason: "Eid e Milad", day: "Friday" },
  {
    date: "02-10-2025",
    reason: "Mahatma Gandhi Jayanti & Vijaya Dashami",
    day: "Thursday",
  },
  { date: "21-10-2025", reason: "Diwali", day: "Tuesday" },
  { date: "05-11-2025", reason: "Guru Nanak Jayanti", day: "Wednesday" },
  { date: "25-12-2025", reason: "Christmas Day", day: "Thursday" },
];
